
<section class="content card">
  <div class="md:col-12">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{ "Locación" | translate }}</h3>
      </div>
      <app-location-form [LocationEdit]="Location$ | async"></app-location-form>
    </div>
  </div>
</section>
